import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import type { TExportPdfData } from "../types";

export type PdfExportStatus = "idle" | "generating";

interface IState {
  status: PdfExportStatus;
  // The export request currently being processed.
  request: TExportPdfData | null;
  // Once-guard so the manager's effect starts the export a single time.
  startedJob: boolean;
}

interface IActions {
  // Returns false when an export is already running — overlapping requests
  // are rejected, not queued (the manager's start effect wouldn't re-fire
  // and the active run's cleanup would silently drop a replaced request).
  startExport: (request: TExportPdfData) => boolean;
  markStarted: () => void;
  reset: () => void;
}

const initState: IState = {
  status: "idle",
  request: null,
  startedJob: false,
};

export const usePdfExportStore = create<IState & IActions>((set, get) => ({
  ...initState,
  startExport: (request) => {
    if (get().status === "generating") return false;
    set({ ...initState, status: "generating", request });
    return true;
  },
  markStarted: () => set({ startedJob: true }),
  reset: () => set({ ...initState }),
}));

export const usePdfExportStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => usePdfExportStore(useShallow(selector));
